import { render, staticRenderFns } from "./tabs.vue?vue&type=template&id=53c936ba&scoped=true&"
import script from "./tabs.js?vue&type=script&lang=js&"
export * from "./tabs.js?vue&type=script&lang=js&"
import style0 from "./tabs.scss?vue&type=style&index=0&id=53c936ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c936ba",
  null
  
)

export default component.exports